export const messages = (state) => state.messages.messages;
export const messagesCount = (state) => state.messages.count;
export const currentMessage = (state) => state.messages.currentMessage;
export const isLoading = (state) => state.messages.loading;
export const error = (state) => state.messages.error;
export const isSending = (state) => state.messages.sending;
export const sendSuccess = (state) => state.messages.sendSuccess;
export const sendError = (state) => state.messages.sendError;

// Get unread messages count
export const unreadCount = (state) => {
    return state.messages.messages.filter(msg => !msg.isRead).length;
};

